module.exports = __webpack_public_path__ + "img/icon-star2-active.2f128ad9.png";